import DelegateSignatureScreen from './DelegateSignatureScreen';

export default DelegateSignatureScreen;
